import React from 'react'

import { Card, Text } from '../../Components'
import { cap } from '../../State'
import { translations } from '../../translations'

const language = cap.language.state || 'IT'
const t = translations[language]

export const CardResult = ({ result, type }) => {
  if (type === 'Hotel') {
    return (
      <Card style={{ width: 300 }}>
        {result?.quoteType && (
          <Text
            center
            value={`${t.tdTipo}: ${result.quoteType}`}
            bold
            title
            size={18}
            style={{ marginBottom: 10 }}
          />
        )}
        <Text center value={result.nameHotel} bold title size={16} style={{ marginBottom: 10 }} />
        <Text
          center
          value={`${t.tdTypeRoom}: ${result.typeRoom}`}
          title
          size={14}
          style={{ marginBottom: 10 }}
        />
        <Text
          center
          value={`${t.tdTrattamento}: ${result.treatment}`}
          title
          size={14}
          style={{ marginBottom: 10 }}
        />
        <Text
          center
          value={`${t.tdCitta}: ${result.location}`}
          title
          size={14}
          style={{ marginBottom: 10 }}
        />
        <Text
          center
          value={`${t.tdIndirizzo}: ${result.address}`}
          title
          size={14}
          style={{ marginBottom: 10 }}
        />
        <Text
          center
          value={`${t.tdLatitudine}: ${result.latitudine}`}
          title
          size={14}
          style={{ marginBottom: 10 }}
        />
        <Text
          center
          value={`${t.tdLongitudine}: ${result.longitudine}`}
          title
          size={14}
          style={{ marginBottom: 10 }}
        />
        <Text
          center
          bold
          value={`${t.tdDistanza}: ${parseInt(result?.distanza)} ${t.tdMetri}`}
          title
          size={14}
          style={{ marginBottom: 10 }}
        />
        <Text
          center
          value={`${t.tdDataCancellazione}: ${result.cancellationDate}`}
          title
          size={14}
          style={{ marginBottom: 10 }}
        />
        <Text
          center
          value={`${t.tdEchoToken}: ${result.echoToken}`}
          title
          size={14}
          style={{ marginBottom: 10 }}
        />
        <Text
          center
          value={`${t.tdPrezzo}: ${result.price}`}
          title
          size={14}
          style={{ marginBottom: 10 }}
        />
      </Card>
    )
  }
  if (type === 'Train') {
    return (
      <Card style={{ width: 300 }}>
        {result?.quoteType && (
          <Text
            center
            value={`${t.tdTipo}: ${result.quoteType}`}
            bold
            title
            size={18}
            style={{ marginBottom: 10 }}
          />
        )}
        {result?.routes?.map((route, ind) => (
          <React.Fragment key={ind}>
            <Text
              center
              value={`${t.tdTrattaN}${ind + 1}`}
              bold
              title
              size={16}
              style={{ marginBottom: 10 }}
            />
            <Text
              center
              value={`${t.tdCompagnia}: ${route.companyLabel}`}
              title
              size={16}
              style={{ marginBottom: 10 }}
            />
            <Text
              center
              value={`${t.tdClasse}: ${route.classTrain}`}
              title
              size={14}
              style={{ marginBottom: 10 }}
            />
            <Text
              center
              value={`${t.tdTipo}: ${route.typeTrenoDescription}`}
              title
              size={14}
              style={{ marginBottom: 10 }}
            />
            <Text
              center
              value={`${t.tdPartenza}: ${route.labelStationDeparture}`}
              title
              size={14}
              style={{ marginBottom: 10 }}
            />
            <Text
              center
              value={`${t.tdArrivo}: ${route.labelStationArrival}`}
              title
              size={14}
              style={{ marginBottom: 10 }}
            />
            <Text
              center
              value={`${t.tdDataPartenza}: ${route.dateDeparture}`}
              title
              size={14}
              style={{ marginBottom: 10 }}
            />
            <Text
              center
              value={`${t.tdDataArrivo}: ${route.dateArrival}`}
              title
              size={14}
              style={{ marginBottom: 10 }}
            />
            <Text
              center
              value={`${t.tdOraPartenza}: ${route.hourDeparture}`}
              title
              size={14}
              style={{ marginBottom: 10 }}
            />
            <Text
              center
              value={`${t.tdOraArrivo}: ${route.hourArrival}`}
              title
              size={14}
              style={{ marginBottom: 10 }}
            />
            <Text
              center
              value={`${t.tdDurata}: ${route.journeyDuration}`}
              title
              size={14}
              style={{ marginBottom: 10 }}
            />
            <Text
              center
              value={`${t.tdEchoToken}: ${route.echoToken}`}
              title
              size={14}
              style={{ marginBottom: 10 }}
            />
            {ind !== result?.routes?.length - 1 && <hr style={{ width: '80%', margin: 10 }} />}
          </React.Fragment>
        ))}
        <Text
          center
          value={`${t.tdPrezzo}: ${result.price}`}
          title
          size={14}
          style={{ marginBottom: 10 }}
        />
      </Card>
    )
  }
  if (type === 'Plane') {
    return (
      <Card style={{ width: 300 }}>
        {result?.quoteType && (
          <Text
            center
            value={`${t.tdTipo}: ${result.quoteType}`}
            bold
            title
            size={18}
            style={{ marginBottom: 10 }}
          />
        )}
        {result?.routes?.map((route, ind) => (
          <React.Fragment key={ind}>
            <Text
              center
              value={`${t.tdTrattaN}${ind + 1}`}
              bold
              title
              size={16}
              style={{ marginBottom: 10 }}
            />
            <Text
              center
              value={`${t.tdCompagnia}: ${route.companyLabel}`}
              title
              size={16}
              style={{ marginBottom: 10 }}
            />
            <Text
              center
              value={`${t.tdClasse}: ${route.classPlane}`}
              title
              size={14}
              style={{ marginBottom: 10 }}
            />
            <Text
              center
              value={`${t.tdPartenza}: ${route.labelDeparture}`}
              title
              size={14}
              style={{ marginBottom: 10 }}
            />
            <Text
              center
              value={`${t.tdArrivo}: ${route.labelArrival}`}
              title
              size={14}
              style={{ marginBottom: 10 }}
            />
            <Text
              center
              value={`${t.tdDataPartenza}: ${route.dateDeparture}`}
              title
              size={14}
              style={{ marginBottom: 10 }}
            />
            <Text
              center
              value={`${t.tdDataArrivo}: ${route.dateArrival}`}
              title
              size={14}
              style={{ marginBottom: 10 }}
            />
            <Text
              center
              value={`${t.tdOraPartenza}: ${route.hourDeparture}`}
              title
              size={14}
              style={{ marginBottom: 10 }}
            />
            <Text
              center
              value={`${t.tdOraArrivo}: ${route.hourArrival}`}
              title
              size={14}
              style={{ marginBottom: 10 }}
            />
            {route.additionalServicesDetailed?.length && (
              <>
                <Text
                  center
                  value={`${t.tdServiziAggiuntivi}: `}
                  title
                  size={14}
                  style={{ marginBottom: 10 }}
                />
                {route.additionalServicesDetailed?.map(({ name, amount, currency }, ind) => (
                  <Text
                    key={ind}
                    center
                    value={`${ind + 1}) ${name} ${amount} ${currency}`}
                    title
                    size={14}
                    style={{ marginBottom: 10 }}
                  />
                ))}
              </>
            )}
            <Text
              center
              value={`${t.tdMiniRules}: ${route.miniRules}`}
              title
              size={14}
              style={{ marginBottom: 10 }}
            />
            <Text
              center
              value={`${t.tdEchoToken}: ${route.echoToken}`}
              title
              size={14}
              style={{ marginBottom: 10 }}
            />
            {ind !== result?.routes?.length - 1 && <hr style={{ width: '80%', margin: 10 }} />}
          </React.Fragment>
        ))}
        <Text
          center
          value={`${t.tdPrezzo}: ${result.price}`}
          title
          size={14}
          style={{ marginBottom: 10 }}
        />
        {result.ancillaryPrice && (
          <Text
            center
            value={`${t.tdPrezzoAncillary}: ${result.totalPrice || ''}`}
            title
            size={14}
            style={{ marginBottom: 10 }}
          />
        )}
      </Card>
    )
  }
  return null
}
